import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Seguro con diabetes?',
    answer: 'Sí, los remedios son naturales. Muestra tus tracks a tu doctor para que vea tus patrones y ajuste tu tratamiento.'
  }, {
    question: '¿Solo digital o puedo imprimir?',
    answer: 'Ambos. Recibes PDF para imprimir y versión editable en Canva/Google Docs. Imprime en Staples por ~$2.'
  }, {
    question: '¿Hay reembolso?',
    answer: 'No ofrecemos reembolsos, pero puedes probar el Template 1 gratis antes de comprar para ver si te funciona.'
  }, {
    question: '¿Funciona para perimenopausia?',
    answer: 'Perfecto para perimenopausia. Los síntomas son los mismos y el tracking te ayuda a identificar patrones irregulares.'
  }, {
    question: '¿En qué idioma están?',
    answer: 'Español USA neutro (comprensible para mexicanas, colombianas, puertorriqueñas, etc.).'
  }, {
    question: '¿Cuánto cuesta imprimir?',
    answer: 'En Staples o FedEx Office cuesta aproximadamente $2-3 imprimir todo el set.'
  }, {
    question: '¿Garantizan resultados?',
    answer: 'No garantizamos resultados específicos. Tu consistencia y compromiso diario dictan los resultados.'
  }, {
    question: '¿Recibiré actualizaciones?',
    answer: 'Sí, todas las actualizaciones futuras son gratis para compradores.'
  }, {
    question: '¿Puedo compartir con familia?',
    answer: 'Puedes compartir con tu familia inmediata, pero no para reventa o distribución comercial.'
  }];
  return <section ref={ref} className="w-full gradient-purple-soft py-20 px-4 sm:px-6 lg:px-8" data-id="element-37">
      <div className="max-w-4xl mx-auto" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-39">
          <h2 className="text-purple-deep text-4xl sm:text-5xl md:text-6xl font-bold font-heading mb-6" data-id="element-40">
            Preguntas:
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-41">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-md overflow-hidden" data-id="element-42">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-purple-50 transition-colors duration-200" aria-expanded={openIndex === index} data-id="element-43">
                <span className="text-purple-deep text-lg sm:text-xl font-bold font-heading pr-4" data-id="element-44">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-purple-main flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-45" />
              </button>
              <motion.div initial={false} animate={{
            height: openIndex === index ? 'auto' : 0,
            opacity: openIndex === index ? 1 : 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-46">
                <div className="px-6 pb-6" data-id="element-47">
                  <p className="text-gray-700 text-lg leading-relaxed" data-id="element-48">
                    {faq.answer}
                  </p>
                </div>
              </motion.div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}